import { ROUTES } from 'src/constants';
import { IRootStore } from '@src/models';

type HandlerArgs = {
  action: {
    tree: IRootStore;
  };
};

export const companyProfileFlows = {
  [ROUTES.employer.companyProfile.base]: {
    exact: false,
    call: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.getIndustries();
      action.tree.resourcesStore.getCountries();
    },
    abort: ({ action }: HandlerArgs) => {
      action.tree.resourcesStore.abort();
    }
  }
};
